import { Project } from '../types';

export const projects: Project[] = [
  {
    id: 'project-shop',
    title: 'Kynothan Art Shop',
    description: 'projects.shop.description',
    longDescription: 'projects.shop.longDescription',
    imageUrl: '/img/IMG_20260327_081744.jpg',
    images: ['/img/IMG_20251108_124748.jpg', '/img/IMG_20260327_081654.jpg', '/img/IMG_20260414_161330.jpg'],
    tags: ['e-commerce', 'art', 'prints'],
    tools: ['shopify'],
    date: '2026',
    link: 'https://shop.kynothan.com/',
  },
  {
    id: 'project-pixel-art',
    title: 'Pixel Art Animation',
    description: 'projects.pixelArt.description',
    longDescription: 'projects.pixelArt.longDescription',
    imageUrl: '/img/Sky_02(x1000).gif',
    images: ['/img/Sky_02(x1000).gif', '/img/2022-09-15_16-48_2 - 58 frames speed.gif'],
    tags: ['animation', 'pixel-art', 'gif'],
    tools: ['Aseprite'],
    date: '2022',
  },
  {
    id: 'project-website',
    title: 'Kynothan.com Portfolio',
    description: 'projects.website.description',
    longDescription: 'projects.website.longDescription',
    imageUrl: '/img/2026.08.06.13.10.50_1497_chrome_[1920-993].png',
    images: [],
    tags: ['web-development', 'portfolio', 'frontend'],
    tools: ['React', 'TypeScript', 'Tailwind CSS'],
    date: '2026',
    link: 'https://kynothan.com/',
  },
  {
    id: 'project-cuisine',
    title: 'Cuisine Kynothan',
    description: 'projects.cuisine.description',
    longDescription: 'projects.cuisine.longDescription',
    imageUrl: '/img/2026.08.06.13.32.10_1499_chrome_[1920-993].png',
    images: [],
    tags: ['wiki', 'food', 'documentation'],
    tools: ['React', 'TypeScript', 'Docusaurus', 'Obsidian', 'Markdown'],
    date: '2026',
    link: 'https://cuisine.kynothan.com/',
  },
  {
    id: 'project-hyperlapse',
    title: 'Building Hyperlapse',
    description: 'projects.hyperlapse.description',
    longDescription: 'projects.hyperlapse.longDescription',
    imageUrl: '/img/8.jpg',
    images: ['/img/8.jpg', '/img/19.jpg', '/img/35.jpg'],
    tags: ['video', 'hyperlapse', 'editing'],
    tools: ['After Effects', 'DaVinci Resolve'],
    date: '2022',
  },
];

export const getProjectById = (id: string) => projects.find((p) => p.id === id);
